export default "<div id=\"{{::$ctrl.id}}\" class=\"tab-pane\" ng-class=\"{'selected': $ctrl.selected}\" ng-transclude></div>"